import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap'
import CustomButton from './CustomButton'
import { GradientThree } from '../gradientThree';

const BannerFive = () => {
  const navigate = useNavigate();
  // useEffect(() => {
   
  //   const gradient = new GradientThree();
  //   gradient.initGradient("#gradient-canvas-three");
  // }, []);
  return (
    <>
    <div className="voloto-banner speed-banner" style={{backgroundImage: "url('/images/Gcc-setup.webp'), linear-gradient(#f0f0f0, #ccc)"}}>
    
      <div className="container position-relative h-85" >
      <Row className='h-100'>
          <Col lg={12} className='h-100 d-flex align-items-center'>
          <div className='volto-banner-header'>
            <h1 className='banner-two-text'>Launch & Scale - GCC</h1>
            <h3 className='banner-three-sub-head'>From concept to completion</h3>
          
            <p className='mt-4 mb-5 volto-margin '>
              Comprehensive, end-to-end support <br /> to build and scale your GCC seamlessly.
              
               {/* Pre-screened GCC & India leaders <br />VP/Director/CTO in 30–45 days<br /> Confidential search & market insights */}
               
               </p>
            
            <div className='mt-5 volto-banner-btn-home'><CustomButton buttonText='Let’s Connect' buttonType='bannerBtn' onClick={() => navigate("/contact")} arrow /></div>
            
            </div>
          </Col>
        </Row>
        <div className="">
          {/* Style tag for inline keyframes */}
          <style>
            {`
              @keyframes colorCycle {
                0% {
                  color: black;
                }
                25% {
                  color: black;
                }
                50% {
                  color: white;
                }
                75% {
                  color: white;
                }
                100% {
                  color: black;
                }
              }
              .color-animate {
                animation: colorCycle 4s linear infinite;
              }
            `}
          </style>
         
        </div>
      </div>
      
    </div>


    </>

    
  )
}

export default BannerFive


{/* <>
<div className="voloto-banner" >

  <canvas
    id="gradient-canvas-three"
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      "--gradient-color-1": "#3C40A4",
      "--gradient-color-2": "#00034F",
      "--gradient-color-3": "#000065",
    }}
  />

  <div className="container position-relative h-85" >
  <Row className='h-100'>
      <Col lg={12} className='h-100 d-flex align-items-center'>
      <div className='volto-banner-header'>
        <h1 className='banner-two-text'>Speed and Agility</h1>
        <h3 className='banner-three-sub-head'>The Core of Our Consulting Excellence</h3>
      
        <p className='mt-4 mb-5 volto-margin '> Our dynamic approach combines rapid market insights, <br />adaptive strategies, and  efficient execution to drive accelerated growth</p>
        
        <div className='mt-5 volto-banner-btn-home'><CustomButton buttonText='Let’s Connect' buttonType='bannerBtn' onClick={() => navigate("./contact")} arrow /></div>
        
        </div>
      </Col>
    </Row>
    <div className="">
    
      <style>
        {`
          @keyframes colorCycle {
            0% {
              color: black;
            }
            25% {
              color: black;
            }
            50% {
              color: white;
            }
            75% {
              color: white;
            }
            100% {
              color: black;
            }
          }
          .color-animate {
            animation: colorCycle 4s linear infinite;
          }
        `}
      </style>
     
    </div>
  </div>
  
</div>


</> */}